// extracted by mini-css-extract-plugin
export default {"card":"tQPwvV84","title":"r_t8KLJM","content":"Fgw9o8Ex","contentElem":"TdwFcCrK"};
    if(module.hot) {
      // 1738090063579
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  